// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings__settings___p4MfJ {
    --setting-width: 32rem;

    display: flex;
    flex-direction: column;
    width: var(--setting-width);
}

.Settings__settingsBlock___Lus3l {
    display: flex;
    flex-direction: column;
    gap: var(--space-xs);

    width: 100%;
    padding: var(--space-s);
}

.Settings__settingHeader___AF0b8 {
    padding: var(--space-xs) var(--space-s);
}

.Settings__headerTitle____gxaX {
    --right-side-width: 11rem;

    overflow: hidden;
    width: calc(var(--setting-width) - var(--right-side-width));
    text-overflow: ellipsis;
    white-space: nowrap;

    &.Settings__withApplyButton___X2Rdy {
        --right-side-width: 14rem;
    }
}

.Settings__headerRightSide___wuIdi {
    display: flex;
    gap: var(--space-2xs);
    align-items: center;
}

.Settings__loader___t7aLC {
    /* stylelint-disable-next-line custom-property-pattern -- переменная Consta */
    --backgroundColor: var(--color-typo-ghost);

    cursor: progress;

    align-items: center;
    justify-content: center;

    width: var(--control-height-xs);
    height: var(--control-height-xs);

    background-color: var(--color-bg-ghost);
    border: none;
    border-radius: var(--control-radius);
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/model/Actions/CommonRenderers/Settings/Settings.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;;IAEtB,aAAa;IACb,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;;IAEpB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;;IAEzB,gBAAgB;IAChB,2DAA2D;IAC3D,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,6EAA6E;IAC7E,0CAA0C;;IAE1C,gBAAgB;;IAEhB,mBAAmB;IACnB,uBAAuB;;IAEvB,+BAA+B;IAC/B,gCAAgC;;IAEhC,uCAAuC;IACvC,YAAY;IACZ,oCAAoC;AACxC","sourcesContent":[".settings {\n    --setting-width: 32rem;\n\n    display: flex;\n    flex-direction: column;\n    width: var(--setting-width);\n}\n\n.settingsBlock {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-xs);\n\n    width: 100%;\n    padding: var(--space-s);\n}\n\n.settingHeader {\n    padding: var(--space-xs) var(--space-s);\n}\n\n.headerTitle {\n    --right-side-width: 11rem;\n\n    overflow: hidden;\n    width: calc(var(--setting-width) - var(--right-side-width));\n    text-overflow: ellipsis;\n    white-space: nowrap;\n\n    &.withApplyButton {\n        --right-side-width: 14rem;\n    }\n}\n\n.headerRightSide {\n    display: flex;\n    gap: var(--space-2xs);\n    align-items: center;\n}\n\n.loader {\n    /* stylelint-disable-next-line custom-property-pattern -- переменная Consta */\n    --backgroundColor: var(--color-typo-ghost);\n\n    cursor: progress;\n\n    align-items: center;\n    justify-content: center;\n\n    width: var(--control-height-xs);\n    height: var(--control-height-xs);\n\n    background-color: var(--color-bg-ghost);\n    border: none;\n    border-radius: var(--control-radius);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settings": `Settings__settings___p4MfJ`,
	"settingsBlock": `Settings__settingsBlock___Lus3l`,
	"settingHeader": `Settings__settingHeader___AF0b8`,
	"headerTitle": `Settings__headerTitle____gxaX`,
	"withApplyButton": `Settings__withApplyButton___X2Rdy`,
	"headerRightSide": `Settings__headerRightSide___wuIdi`,
	"loader": `Settings__loader___t7aLC`
};
export default ___CSS_LOADER_EXPORT___;
